import axios from 'axios'
import toast from 'react-hot-toast'
import helpers from '../utils/helpers'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = helpers.getSession('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // ✅ Detect FormData and avoid overriding Content-Type
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json'
    } else {
      // Let Axios set it automatically (for boundary)
      delete config.headers['Content-Type']
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for success envelope
api.interceptors.response.use(
  (response) => {
    // Ensure callers get { success, data } shape
    if (response && response.data && typeof response.data === 'object' && 'data' in response.data) {
      return response.data
    }
    return { success: true, data: response.data }
  },
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem('token')
      // localStorage.removeItem('userRole')
      window.location.href = '/SessionExpiredModal'
      toast.error('Session expired. Please login again.')
    } else if (error.response?.status === 403) {
      toast.error('Access denied. Insufficient permissions.')
    } else if (error.response?.status >= 500) {
      toast.error('Server error. Please try again later.')
    }

    return Promise.reject(error)
  }
)

export default api